import { TrialHeaderQueryHookResult, useTrialInfoQuery } from "@generated/graphql";
import CircularLoading from "components/CircularLoading";
import useIsCreate from "hooks/useIsCreate";
import useGetCompetencyMapOptions from "pages/Testing/view/hooks/useGetCompetencyMapOptions";
import { useParams } from "react-router-dom";
import InfoTabContent from "./Content";

interface InfoTabProps {
  refetchTrialHeader: TrialHeaderQueryHookResult["refetch"];
}

const InfoTab = ({ refetchTrialHeader }: InfoTabProps) => {
  const isCreate = useIsCreate();
  const { id } = useParams();

  const { data, loading: trialInfoLoading } = useTrialInfoQuery({
    variables: {
      trialId: id!,
    },
    skip: !id,
  });
  const trial = data?.trial;

  const { competencyMapsOptions, loading: competencyMapsLoading } = useGetCompetencyMapOptions();

  const loading = trialInfoLoading || (isCreate && competencyMapsLoading);

  if (loading || (!trial && !isCreate)) return <CircularLoading />;

  return (
    <InfoTabContent
      trial={trial}
      trialInfoLoading={loading}
      competencyMapsOptions={competencyMapsOptions}
      competencyMapsLoading={competencyMapsLoading}
      refetchTrialHeader={refetchTrialHeader}
    />
  );
};

export default InfoTab;
